import { z } from 'zod'

export const shopifyCreateVariantsParamsSchema = z.object({
  productId: z.string(),
  strategy: z.enum(['REMOVE_STANDALONE_VARIANT']),
  variants: z.array(
    z.object({
      optionValues: z.array(
        z.object({
          optionName: z.enum(['size']),
          name: z.string(),
        })
      ),
      price: z.number(),
      compareAtPrice: z.number(),
      inventoryQuantities: z.object({
        availableQuantity: z.number(),
        locationId: z.string(),
      }),
    })
  ),
})

export type ShopifyCreateVariantsParams = z.infer<typeof shopifyCreateVariantsParamsSchema>

export const shopifyCreateProductParamsSchema = z.object({
  product: z.object({
    title: z.string(),
    handle: z.string(),
    status: z.enum(['ACTIVE']),
    productType: z.string(),
    category: z.string(),
    metafields: z.array(
      z.object({
        namespace: z.string(),
        value: z.string(),
        type: z.enum(['integer']),
        key: z.string(),
      })
    ),
  }),
  media: z.array(
    z.object({
      originalSource: z.string(),
      alt: z.string(),
      mediaContentType: z.enum(['IMAGE']),
    })
  ),
})

export type ShopifyCreateProductParams = z.infer<typeof shopifyCreateProductParamsSchema>

export const createVariantsResponseSchema = z.object({
  createdVariants: z.array(
    z.object({
      id: z.string(),
      title: z.string(),
      inventoryItem: z.object({
        id: z.string(),
      }),
      selectedOptions: z.array(
        z.object({
          name: z.string(),
          value: z.string(),
        })
      ),
    })
  ),
  product: z.object({
    id: z.string(),
    title: z.string(),
    variants: z.object({
      nodes: z.array(
        z.object({
          id: z.string(),
          title: z.string(),
          selectedOptions: z.array(
            z.object({
              name: z.string(),
              value: z.string(),
            })
          ),
        })
      ),
    }),
  }),
})

export type CreateVariantsResponse = z.infer<typeof createVariantsResponseSchema>

export const setQuantitiesParamsSchema = z.object({
  name: z.enum(['available']),
  reason: z.enum(['correction']),
  quantities: z.array(
    z.object({
      inventoryItemId: z.string(),
      locationId: z.string(),
      quantity: z.number(),
      compareQuantity: z.number().optional(),
    })
  ),
})

export type SetQuantitiesParams = z.infer<typeof setQuantitiesParamsSchema>

export const updateVariantsParamsSchema = z.object({
  productId: z.string(),
  variants: z.array(
    z.object({
      id: z.string(),
      price: z.number(),
      compareAtPrice: z.number(),
    })
  ),
})

export type UpdateVariantsParams = z.infer<typeof updateVariantsParamsSchema>

export const deleteProductParamsSchema = z.object({ productId: z.string() })
export type DeleteProductParams = z.infer<typeof deleteProductParamsSchema>
